<template>
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 1C3.8645 1 0.5 4.3645 0.5 8.5C0.5 12.6355 3.8645 16 8 16C12.1355 16 15.5 12.6355 15.5 8.5C15.5 4.3645 12.1355 1 8 1ZM8 14.5C4.69175 14.5 2 11.8082 2 8.5C2 5.19175 4.69175 2.5 8 2.5C11.3082 2.5 14 5.19175 14 8.5C14 11.8082 11.3082 14.5 8 14.5Z"/>
        <path d="M8.75 4.75H7.25V9.25H11.75V7.75H8.75V4.75Z"/>
    </svg>
</template>
